// src/services/TermsService.js
import api from './Api';

const BASE_URL = 'terms/';

export default {
  getTerms: () => {
    return api.get(BASE_URL, {
      responseType: 'blob' // Important for handling PDF files
    });
  },
  getUserTermsUrl: (userId) => {
    return api.get(`${BASE_URL}${userId}`);
  }
};